import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

import { CommonService} from '../common.service'
import { SharedService } from '../shared.service'

@Component({
  selector: 'hn-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LocationComponent implements OnInit, OnDestroy{

  subscription;
  searchText;
  address;
  results;
  mobile=false;
  iPad=false;

  constructor(private commonService: CommonService, private sharedService: SharedService, private modalService:NgbModal){
    this.subscription = sharedService.homeAddress$.subscribe(
      addres => {
        this.address = addres;
        if (this.address) {
          this.searchText = JSON.parse(this.address);   //console.log("this.searchText22222222222--", this.searchText);
        }
      });
  }

  ngOnInit() {
    if (window.screen.width <768) { // 768px portrait
      this.mobile = true;
    }
    else if (window.screen.width <1000){
      this.iPad = true
    }
    this.address = this.sharedService.getHomeAddress();
    //console.log("this.address from sharedSession", this.address);
    if (this.address) {
      this.searchText = JSON.parse(this.address);   //console.log("this.searchText22222222222--", this.searchText);
    }
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

  search(event) { //for primeng autocomplete
    this.address = this.sharedService.getHomeAddress();
    //console.log("event -- ", event.query, 'address ->', this.address)
    this.commonService.getAddresses(event.query).subscribe(
      addresses => {
        //this.results = addresses.results;  //for maps.googleapis.com/maps/api/geocode/json?address= URL
        //this.results = addresses.predictions;  //for maps.googleapis.com/maps/api/place/autocomplete/json?input= URL //not working bcoz of CORS/JSONP issues Google wont support
        //console.log("suggested addresses", addresses.predictions);
        this.results= addresses.suggestions;
      },
      err => console.error("Error in search() call::", err),
      () => {
        //console.log('done loading addresses')//like finally.......
      }
    );
  }

  resetAddress() { //for primeng autocomplete
    //console.log("resetAddress event -- ", 'address ->', this.address, 'searchText-', this.searchText)
    this.address = "";
    this.searchText="";
    this.sharedService.setHomeAddress("");
  }

  onSelectHandler(){
    //console.log(1234, this.searchText, JSON.stringify(this.searchText));
    this.sharedService.setHomeAddress(JSON.stringify(this.searchText));
  }
  open(content) {
    this.modalService.open(content, { size: 'lg', windowClass: 'modal-adaptive' });
  }
}
